import {coreApi} from './core'

export const userService = {
    getAll: async () => coreApi.get(`user`),
    getByRole: async () => coreApi.get(`user/driver`),
    getById: async (id) => coreApi.get(`user?id=${id}`),
    create: async (data) => coreApi.post(`user`, data),
    update: async (data) => coreApi.put(`user`, data)
}